import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

export default function Plus({
  attributes = {
    color: "",
    classes: "",
    size: "",
  },
  clickHandler = () => {},
}) {
  const navigate = useNavigate();
  return (
    <div className={attributes.classes} onClick={clickHandler}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={attributes.size}
        height={attributes.size}
        viewBox="0 0 39.5 20"
      >
        <text
          id="_"
          data-name="+"
          transform="translate(0 34)"
          fill={attributes.color}
          fontSize="70"
          fontFamily="SourceSansPro-Semibold, Source Sans Pro"
          fontWeight="600"
        >
          <tspan x="0" y="0">
            +
          </tspan>
        </text>
      </svg>
    </div>
  );
}
